import SweetScroll from 'sweet-scroll';
import MediaQuery from '../lib/MediaQuery';

/**
 * ハッシュ付きのリンクをスムーススクロールで移動します。
 * https://github.com/tsuyoshiwada/sweet-scroll
 * import scroller from './scroller';
 * scroller.toElement(document.getElementById('elm'));
 */
let offset;
MediaQuery.matches('lg', matches => {
  if (matches) {
    offset = -70;
  } else {
    offset = -46;
  }
});
export default new SweetScroll({
  header: null, // 固定ヘッダをCSSセレクタで指定
  duration: 1000, // アニメーション再生時間のミリ秒
  easing: 'easeOutQuint', // イージングのタイプ
  offset, // スクロール位置のオフセット
  vertical: true, // 垂直方向のスクロールを許可する
  horizontal: false, // 水平方向のスクロールを許可する
  cancellable: true, // ホイールやタッチイベント発生時にスクロールを停止する
  updateURL: true, // スクロール完了後にURLを更新する
  preventDefault: true, // コンテナ要素のクリックイベントを防止する
  stopPropagation: true, // コンテナ要素のバブリングを防止する

  // スクロール先要素にフォーカスを変更する
  before(_, $trigger, scrollElement) {
    if (scrollElement.ctx.hash) {
      const destination = document.getElementById(scrollElement.ctx.hash.replace('#', ''));
      destination.setAttribute('tabindex', '-1');
      setTimeout(() => {
        destination.focus();
      }, 0);
    }
  },
});
